module.exports = __webpack_public_path__ + "static/media/DSC09599-4.bcb8206c.jpg";